import { TextField, Stack } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';

const LessonFilters = ({
  topicFilter,
  onTopicChange,
  dateFrom,
  onDateFromChange,
  dateTo,
  onDateToChange,
}) => (
  <Stack direction={{ xs: 'column', md: 'row' }} spacing={2} alignItems={{ md: 'flex-end' }}>
    <TextField
      label="Пошук за темою"
      placeholder="Наприклад: дроби"
      value={topicFilter}
      onChange={(e) => onTopicChange(e.target.value)}
      fullWidth
    />
    <DatePicker
      label="Дата з"
      format="DD.MM.YYYY"
      value={dateFrom ? dayjs(dateFrom) : null}
      onChange={(val) => onDateFromChange(val ? val.format('YYYY-MM-DD') : '')}
      slotProps={{
        textField: { sx: { minWidth: { md: 180 } } },
        field: { clearable: true },
      }}
    />
    <DatePicker
      label="Дата по"
      format="DD.MM.YYYY"
      value={dateTo ? dayjs(dateTo) : null}
      onChange={(val) => onDateToChange(val ? val.format('YYYY-MM-DD') : '')}
      slotProps={{
        textField: { sx: { minWidth: { md: 180 } } },
        field: { clearable: true },
      }}
    />
  </Stack>
);

export default LessonFilters;
